import { API_ERROR_CODES, HTTP_ERROR_CODES } from "./error-codes";
import { ROUTES_LOGIN, SESSION_TOKEN_STORAGE_KEY } from "./constants";
import { format } from "date-fns";
import { store } from "../store";
import { setIdCrmAction, setIdLoginAction, setIdUserAction, setUserTypeAction, setDniAction } from "../reducers";

const findErrorCode = (code) => {
  const httpError = HTTP_ERROR_CODES[code];
  const apiError = API_ERROR_CODES[code];

  return !!httpError || !!apiError;
};

export const getErrorMessage = (errorCode) => {
  if (errorCode === null || errorCode === undefined || !findErrorCode(errorCode)) {
    return "http_error.generic_message";
  }

  return API_ERROR_CODES[errorCode];
};

export const checkGetResult = (result) => {
  return result?.resultado?.codigo === 0;
};

export const formatDate = (date) => {
  if (date === undefined || date === null) {
    return "";
  }
  const fragmentedDate = date.split("/");
  const formattedDate = fragmentedDate[1] + "/" + fragmentedDate[0] + "/" + fragmentedDate[2];
  return new Date(formattedDate);
};

export const formatValidationDate = (date) => {
  if (!date) return " - ";
  return format(new Date(date), "hh:mm:ss - MM/dd/yyyy");
};

/**
 * SESSION UTILS
 */
export const _getSessionToken = () => {
  return sessionStorage.getItem(SESSION_TOKEN_STORAGE_KEY);
};

export const _setSessionToken = (sessionToken) => {
  if (sessionToken) {
    sessionStorage.setItem(SESSION_TOKEN_STORAGE_KEY, sessionToken);
  } else {
    sessionStorage.removeItem(SESSION_TOKEN_STORAGE_KEY);
  }
};

export const resetRedux = () => {
  store.dispatch(setIdCrmAction(""));
  store.dispatch(setIdUserAction(""));
  store.dispatch(setIdLoginAction(""));
  store.dispatch(setDniAction(""));
  store.dispatch(setUserTypeAction(null));
};

export const clearStorage = () => {
  sessionStorage.clear();
  resetRedux();
};

export const clearSession = () => {
  window.location.pathname = ROUTES_LOGIN;
  clearStorage();
};

/**
 * VALIDATIONS
 */
export const validateDNI = (dni) => {
  const regex = /^[0-9]{8,8}[A-Z]$/;
  return regex.test(dni);
};

export const validatePhone = (phone) => {
  const regex = /^(\+[0-9]{2,2}){0,1}[0-9]{9,9}$/;
  return regex.test(phone);
};

export const validateEmail = (email) => {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
};
